import React from "react";

export default function FileDrop(props: React.PropsWithChildren<{ onDrop: (file: File) => void, accept?: string }>) {
	const ref = React.useRef<HTMLDivElement>(null);
	const inputRef = React.useRef<HTMLInputElement>(null);

	const handleDragOver = React.useCallback((e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		ref.current?.setAttribute("data-drag-over", "");
	}, [ref.current]);

	const handleDragLeave = React.useCallback(() => {
		ref.current?.removeAttribute("data-drag-over");
	}, [ref.current]);

	const handleDrop = React.useCallback((e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		ref.current?.removeAttribute("data-drag-over");
		const file = e.dataTransfer.files[0];
		if (file) props.onDrop(file);
	}, [ref.current, props]);

	const handleClick = React.useCallback(() => {
		inputRef.current?.click();
	}, [inputRef.current]);

	const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		if (file) props.onDrop(file);
		e.target.value = "";
	}, [props]);

	return <div
		className="dropzone"
		ref={ref}

		onDragOver={handleDragOver}
		onDragLeave={handleDragLeave}
		onDrop={handleDrop}
		onClick={handleClick}
	>
		{props.children ?? 'Datei Auswählen'}
		<input
			ref={inputRef}
			type="file"
			accept={props.accept}
			hidden
			onChange={handleChange}
		/>
	</div>;
}